"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAlert = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAlert = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  bottom: ", ";\n  z-index: 1000;\n\n  .alert {\n    align-items: center;\n\n    i {\n      font-size: ", ";\n      margin-right: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  bottom: ", ";\n  z-index: 1000;\n\n  .alert {\n    align-items: center;\n\n    i {\n      font-size: ", ";\n      margin-right: ", ";\n    }\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x5;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xl;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
});
var templateObject_1;
